module.exports = __webpack_public_path__ + "static/logohc-9b6fe9398b517833e4a0e3d164d24c9d.svg";